import { OutlineElement } from '../../base/outline-element/outline-element';
import { CSSResultGroup, html, TemplateResult } from 'lit';
import { classMap } from 'lit/directives/class-map.js';

import { customElement, property, state } from 'lit/decorators.js';

import componentStyles from './ghs-staff-card.css.lit';
import '../ghs-icon/ghs-icon';
import { LightController } from '../../controllers/light-controller';

/**
 * The The Staff Card component
 *
 * @element ghs-staff-card
 */
@customElement('ghs-staff-card')
export class GhsStaffCard extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  lightController = new LightController(
    this,
    componentStyles,
    this.tagName.toLowerCase()
  );

  @state()
  hasLocationSlot = false;

  @state() phoneClicked = false;

  /**
   * CTA url.
   */
  @property({ type: String, attribute: 'cta-url', reflect: true })
  ctaUrl: string;

  /**
   * Show links on mobile.
   */
  @property({ type: String, attribute: 'mobile-links', reflect: true })
  mobileLinks = false;

  handleLocationSlotchange(e: Event) {
    // @ts-expect-error ignore TS error.
    const childNodes = e?.target?.assignedNodes({ flatten: true }) || [];

    const allText = childNodes
      .map((node: Node) => {
        return node?.textContent ? node.textContent : '';
      })
      .join('');

    this.hasLocationSlot = allText.length > 0;
  }

  showPhone() {
    this.phoneClicked = true;
  }

  hidePhone() {
    this.phoneClicked = false;
  }

  render(): TemplateResult {
    const locationClasses = {
      'staff-card-location': true,
      'staff-card-location--empty': !this.hasLocationSlot,
    };

    const showMobileLinks = this.mobileLinks ? 'mobile-links' : '';

    return html`
      <div class="staff-card ${showMobileLinks}">
        <div class="staff-card-top-section">
          <div class="staff-card-image">
            <slot name="staff-card-image"></slot>
          </div>
          <div class="staff-card-info-section">
            <div class="staff-card-headline">
              <slot name="staff-card-headline"></slot>
            </div>

            <div class="staff-card-division">
              <slot name="staff-card-division"></slot>
            </div>

            <div class=${classMap(locationClasses)}>
              <div class="staff-card-main-location">Main Location</div>
              <slot
                name="staff-card-location"
                @slotchange=${this.handleLocationSlotchange}
              ></slot>
            </div>

            <div class="staff-card-description">
              <slot name="staff-card-description"></slot>
            </div>
          </div>
        </div>

        <div class="staff-card-cta-section">
          <slot name="staff-card-profile-link"></slot>
          <slot name="staff-card-appointment-link"></slot>
        </div>
        <div class="phone ${this.phoneClicked ? 'show' : 'hide'}">
          <ghs-icon
            name="close-circle-border"
            @click=${this.hidePhone}
            class="staff-icon-close"
            size="20px"
            mobile-size="15px"
            site=${this.site}
          >
          </ghs-icon>
          Please call us to schedule an appoinment.
          <slot name="staff-card-appointment-phone"></slot>
        </div>
      </div>
    `;
  }
}
